<template>
  <div class="text--primary">
    <v-row dense>
      <v-col cols="4">
        <div v-if="loading">
          <px-circular-loading/>
        </div>
        <px-lista-empresas v-if="compradores && compradores.length"
                           :compradores="compradores"
                           :id-comprador-selecionado="idCompradorSelecionado"
                           @change="onChangeComprador"/>
      </v-col>
      <v-col cols="8">
        <px-configuracao-notificacao-comprador :comprador="compradorSelecionado"/>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import CompradorService from '@/api/comprador-service';
import ListaEmpresas from '../components/comprador/ListaComprador.vue';
import ConfiguracaoNotificacaoComprador from '../components/ConfiguracaoNotificacaoComprador.vue';

const LIMIT = 100;

export default {
  data() {
    return {
      loading: false,
      compradores: null,
      compradorSelecionado: null,
    };
  },
  computed: {
    idCompradorSelecionado() {
      return this.compradorSelecionado?.id || null;
    },
  },
  methods: {
    onChangeComprador(comprador) {
      this.compradorSelecionado = comprador;
    },
    getCompradores() {
      this.loading = true;

      CompradorService.getCompradorPage({
        limit: LIMIT,
      })
        .then((response) => {
          this.compradores = response.data.content;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  created() {
    this.getCompradores();
  },
  components: {
    pxListaEmpresas: ListaEmpresas,
    pxConfiguracaoNotificacaoComprador: ConfiguracaoNotificacaoComprador,
  },
};
</script>
